<div class="loading">
  <div class="loading-spinner">
    <i class="fas fa-circle-notch fa-spin"></i>
  </div>
  <p>{{ message || ('common.loading' | transloco) }}</p>
</div>
